export function getAuthors (authorsArray) {
    console.log(authorsArray);
    if (authorsArray.length == 1) {
        let data = authorsArray[0].split(' ');
        return `${data[1].toUpperCase()}, ${data[0]}`;
    } else if (authorsArray.length == 2) {
        let data = authorsArray[0].split(' ');
        let data2 = authorsArray[1].split(' ');
        return `${data[1].toUpperCase()}, ${data[0]} - ${data2[1].toUpperCase()}, ${data2[0]}`;
    } else {
        let data = authorsArray[0].split(' ');
        return `${data[1].toUpperCase()}, ${data[0]} et al.`;
    }
}

export function getFormAuthors (authors) {
    let work;
    if (authors.includes(' - ')) {
        work = authors.split(' - ');
    } else {
        work = [authors.trim()];
    }

    return work;
}